import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';
import { Cross2Icon } from '../icons/Icons';
import { Modal } from '@mui/material';

function UpdateLetterSetupModal({CurrentSession, CurrentSetup, updateLetterResult}){

    const inputRef = useRef(null);
    const idInputRef = useRef(null);
    const idInputDivRef = useRef(null);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [originalClubId, setOriginalClubId] = useState('');
    const [changingClubIdModal, setChangingClubIdModal] = useState(false);
    const [validClubId, setValidClubId] = useState(true);

    const [currentLetter, setCurrentLetter] = useState(CurrentSetup.LetterId);

    const options = [''].concat(
        Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))
    );

    useEffect(() => {
        
        
    },[]);

    const clickResult = (result) => {
        setButtonDisabled(true);
        let value = '';
        if(result){
            value = currentLetter;
        }
        updateLetterResult(result, value);
    };

    const handleChange = (e) => {
        setCurrentLetter(e.target.value);
    }

    return(
        <div className='modal-container' style={{height:"300px", maxWidth:"400px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Update setup letter ID</div>
            <div className='modal-content'>
                <span>Letter ID</span>
                <select value={currentLetter} onChange={handleChange} style={{height:'50px', width:'250px', fontSize:'20px'}}>
                    {options.map((letter) => (
                        <option key={letter} value={letter} style={{height:'30px', fontSize:'20px'}}>
                        {letter === '' ? '(no letter)' : letter}
                        </option>
                    ))}
                </select>
            </div>
            <div className="modal-footer" >
                <button disabled={buttonDisabled} className="button" style={{width:'100px'}} onClick={() => clickResult(true)}>Update</button>
            </div>
        </div>
            );
}

export default UpdateLetterSetupModal;